module.exports = __webpack_public_path__ + "img/img_throw_1@2x_v3.c70c1b33.png";